// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IActivityDetail
 */
export interface IActivityDetail {
    /**
     * 
     * @type {string}
     * @memberof IActivityDetail
     */
    text?: string;
    /**
     * 
     * @type {Date}
     * @memberof IActivityDetail
     */
    timestamp?: Date;
    /**
     * 
     * @type {string}
     * @memberof IActivityDetail
     */
    activity_type?: IActivityDetailActivityTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IActivityDetail
     */
    section_style_type?: IActivityDetailSectionStyleTypeEnum;
}

/**
* @export
* @enum {string}
*/
export enum IActivityDetailActivityTypeEnum {
    FEE = 'FEE',
    FEE_MODIFICATION = 'FEE_MODIFICATION',
    CLAIM_REJECTION_CLAIM_POSTING = 'CLAIM_REJECTION_CLAIM_POSTING',
    CLAIM_REPAYMENT = 'CLAIM_REPAYMENT',
    CLAIM_REPAYMENT_REJECTION = 'CLAIM_REPAYMENT_REJECTION',
    CLAIM_POSTING_PAYMENT = 'CLAIM_POSTING_PAYMENT',
    CLAIM_POSTING_REFUND = 'CLAIM_POSTING_REFUND',
    CLAIM_TRANSFER = 'CLAIM_TRANSFER',
    CLAIM_OFFSET = 'CLAIM_OFFSET',
    ACCOUNT_VERIFICATION = 'ACCOUNT_VERIFICATION',
    CLAIM_INVOICE_PAYMENT = 'CLAIM_INVOICE_PAYMENT',
    DECLINE = 'DECLINE'
}
/**
* @export
* @enum {string}
*/
export enum IActivityDetailSectionStyleTypeEnum {
    DEFAULT = 'DEFAULT',
    ERROR = 'ERROR',
    SUCCESS = 'SUCCESS',
    WARNING = 'WARNING',
    INFO = 'INFO'
}


/**
 * Check if a given object implements the IActivityDetail interface.
 */
export function instanceOfIActivityDetail(value: object): value is IActivityDetail {
    return true;
}

export function IActivityDetailFromJSON(json: any): IActivityDetail {
    return IActivityDetailFromJSONTyped(json, false);
}

export function IActivityDetailFromJSONTyped(json: any, ignoreDiscriminator: boolean): IActivityDetail {
    if (json == null) {
        return json;
    }
    return {
        
        'text': json['text'] == null ? undefined : json['text'],
        'timestamp': json['timestamp'] == null ? undefined : (new Date(json['timestamp'])),
        'activity_type': json['activity_type'] == null ? undefined : json['activity_type'],
        'section_style_type': json['section_style_type'] == null ? undefined : json['section_style_type'],
    };
}

export function IActivityDetailToJSON(json: any): IActivityDetail {
    return IActivityDetailToJSONTyped(json, false);
}

export function IActivityDetailToJSONTyped(value?: IActivityDetail | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'text': value['text'],
        'timestamp': value['timestamp'] == null ? undefined : ((value['timestamp']).toISOString()),
        'activity_type': value['activity_type'],
        'section_style_type': value['section_style_type'],
    };
}

